module.exports = __webpack_public_path__ + "img/logo_chat_cliente.3a44f6a7.png";